import { AfterViewInit, Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { Title } from '@angular/platform-browser';
import * as L from 'leaflet';
import { LayerGroup, Map, control } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Subscription } from 'rxjs';
import { Marker } from 'src/app/models/shared/marker.model';
import { baseTiles } from 'src/app/services/map.service';
import { environment } from 'src/environments/environment';
import { Module } from './models/shared/module-navigation.model';
import { AuthService } from './services/auth.service';
import { MapService } from './services/map.service';
import { MarkersService } from './services/markers.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

/**
 * Questa è la classe principale dell'applicazione.
 * @remarks
 * Questa classe gestisce la mappa, i marcatori e la logica di ricerca.
 * Implementa OnInit e AfterViewInit per gestire l'inizializzazione
 * e il rendering della mappa.
 *
 * @example
 * // Creare un'istanza di AppComponent
 * const app = new AppComponent();
 *
 */
export class AppComponent implements OnInit {
  modules: Module[] = [];
  /**
   * Flag per indicare se il pannello laterale è aperto o chiuso.
   * @public
   */
  sidebarOpen: boolean = true;
  /**
   * La versione dell'applicazione.
   * @public
   */
  version: string = '';
  /**
   * Titolo dell'applicazione.
   * @public
   */
  title = environment.appTitle;
  /**
   * Costruttore della classe AppComponent.
   * @param authService - Il servizio di autenticazione.
   * @param titleService - Il servizio per impostare il titolo della pagina.
   * @param dialog - Il servizio per i dialoghi di Material.
   * @param mapService - Il servizio per la gestione della mappa.
   * @param markersService - Il servizio per i marcatori.
   */
  constructor(
    public authService: AuthService,
    private titleService: Title,
  ) {
    this.titleService.setTitle(this.title);
  }
  /**
   * Metodo chiamato durante l'inizializzazione dell'applicazione.
   * Crea un FormGroup per il modulo di ricerca e imposta l'icona predefinita di Leaflet.
   */
  ngOnInit() {
    let dummy;
  }

}
